import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../ui/card';
import { Clock } from 'lucide-react';

// Placeholder for a screen that is not built yet. It deliberately shows no
// numbers: a page of sample figures is easy to mistake for the business's own.
export default function ComingSoon({ title, note, link }) {
  return (
    <div className="p-6 lg:p-8">
      <Card className="p-8 border-slate-200 max-w-xl" data-testid="coming-soon">
        <div className="flex items-center gap-3">
          <Clock className="w-6 h-6 text-slate-400" />
          <h1 className="text-2xl font-extrabold tracking-tight text-slate-900">{title}</h1>
          <span className="text-xs font-semibold uppercase tracking-wider bg-amber-100 text-amber-700 rounded-full px-2 py-0.5">Coming soon</span>
        </div>
        <p className="text-slate-600 mt-3 text-sm">{note}</p>
        {link && <Link to={link.to} className="inline-block mt-4 text-sm font-semibold text-[#6FA82C] hover:underline">{link.label}</Link>}
      </Card>
    </div>
  );
}
